import { IOfferCard } from '../../../../types';
import { getBuildingDeadline } from '../../utils';

export const prepareJk = (offerCard: IOfferCard) => {
  const { displayName, fullUrl } = offerCard.geo?.jk || {};

  if (offerCard.dealType === 'rent' || !displayName) {
    return;
  }

  const solid = Boolean(offerCard.newbuilding?.showJkReliableFlag);

  return {
    name: displayName,
    deadline: getBuildingDeadline(offerCard),
    url: fullUrl ?? undefined,
    solid,
  };
};
